import * as api from '../api';
import { ActionType, LoadingState } from '../constants/actionTypes';

export const getPost = (id) => async (dispatch) => {
    try {
        dispatch({ type: LoadingState.START_LOADING });
        const { data } = await api.fetchPost(id);

        dispatch({ type: ActionType.FETCH_POST, payload: data });
        dispatch({ type: LoadingState.END_LOADING });
    } catch (error) {
        console.log(error);
    }
}

//Action Creaters
export const getPosts = (page) => async (dispatch) => {
    try {
        dispatch({ type: LoadingState.START_LOADING });
        const { data } = await api.fetchPosts(page);
        dispatch({ type: ActionType.FETCH_ALL, payload: data });
        dispatch({ type: LoadingState.END_LOADING });
    } catch (error) {
        console.log(error);
    }
}

export const getPostsBySearch = (searchQuery) => async (dispatch) => {
    try {
        dispatch({ type: LoadingState.START_LOADING });
        const { data } = await api.fetchPostsBySearch(searchQuery);
        dispatch({ type: ActionType.FETCH_BY_SEARCH, payload: data });
        dispatch({ type: LoadingState.END_LOADING });
    } catch (error) {
        console.log(error);
    }
}

export const createPost = (post, history) => async (dispatch) => {
    try {
        dispatch({ type: LoadingState.START_LOADING });
        const { data } = await api.createPost(post);
        history.push(`posts/${data._id}`);
        dispatch({ type: ActionType.CREATE, payload: data });
        dispatch({ type: LoadingState.END_LOADING });
    } catch (error) {
        console.log(error);
    }
}

export const updatePost = (id, post) => async (dispatch) => {
    try {
        dispatch({ type: LoadingState.START_LOADING });
        const { data } = await api.updatePost(id, post);
        dispatch({ type: ActionType.UPDATE, payload: data });
        dispatch({ type: LoadingState.END_LOADING });
    } catch (error) {
        console.log(error);
    }
}

export const deletePost = (id) => async (dispatch) => {
    try {
        const response = await api.deletePost(id);
        console.log(response.data);
        dispatch({ type: ActionType.DELETE, payload: id });
    } catch (error) {
        console.log(error);
    }
}

export const likePost = (id) => async (dispatch) => {
    try {
        const { data } = await api.likePost(id);
        dispatch({ type: ActionType.UPDATE, payload: data });
    } catch (error) {
        console.log(error);
    }
}

export const commentPost = (comment, id) => async (dispatch) => {
    try {
        const { data } = await api.commentPost(comment, id);
        dispatch({ type: ActionType.COMMENT, payload: data });
        return data.comments;
    } catch (error) {
        console.log(error);
    }
}